import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  return <AnimatePresence data-id="element-145">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-146">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-147" />

          {/* Modal Card */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl max-h-[80vh] bg-[#0a1628]/95 backdrop-blur-xl border border-[#d4a843]/40 rounded-2xl shadow-2xl overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-148">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-[#d4a843]/20 bg-[#0a1628]" data-id="element-149">
              <h2 className="text-2xl font-serif font-bold text-white" data-id="element-150">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-[#d4a843]/10 transition-colors group" aria-label="Cerrar" data-id="element-151">
                <X className="w-6 h-6 text-[#d4a843] group-hover:text-[#e8c66a]" data-id="element-152" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 md:p-8 overflow-y-auto custom-scrollbar text-gray-300 space-y-6" data-id="element-153">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}